/**
 * Admin i18n namespaces.
 */
export enum Ns {
    Actions = 'actions',
    Admin = 'admin',
    Ads = 'ads',
    AdsTxt = 'ads-txt',
    AiPrompts = 'ai-prompts',
    AiResults = 'ai-results',
    Articles = 'articles',
    AuditLogs = 'audit-logs',
    BlockedDomain = 'blocked-domain',
    BlockedIps = 'blocked-ips',
    Bookmaker = 'bookmaker',
    Comments = 'comments',
    Common = 'common',
    Components = 'components',
    Config = 'config',
    Curation = 'curation',
    Datetime = 'datetime',
    Events = 'events',
    Experiments = 'experiments',
    FaqCategories = 'faqCategories',
    Faqs = 'faqs',
    FilteredComments = 'filtered-comments',
    ForbiddenWords = 'forbidden-words',
    IpQs = 'ip-qs',
    MatchReports = 'match-reports',
    MatchTicker = 'match-ticker',
    Meta = 'meta',
    ModuleSchedule = 'module-schedule',
    NavItems = 'nav-items',
    NewsCategory = 'news-category',
    Notificationbar = 'notificationbar',
    Oddsdossier = 'oddsdossier',
    OptaExports = 'opta-exports',
    Pages = 'pages',
    Poll = 'poll',
    Propositions = 'propositions',
    Recaptcha = 'recaptcha',
    Redirects = 'redirects',
    RichEditor = 'rich-editor',
    Sandbox = 'sandbox',
    Standing = 'standing',
    Stats = 'stats',
    Subscribe = 'subscribe',
    SubscriptionGifts = 'subscription-gifts',
    Tags = 'tags',
    TierGroups = 'tier-groups',
    Tiers = 'tiers',
    Url = 'url',
    User = 'user',
    Videofeed = 'videofeed',
}
